export const RoutingConstants = {
  concessionaireRouting: {
    edit: "/concesionario/edicion",
    create: "/concesionario/creacion",
    list: "/concesionario/lista",
    id: "coId",
  },
  maintenanceUser: {
    edit: "/maintenance-usuario/edicion",
    create: "/maintenance-usuario/creacion",
    list: "/maintenance-usuario/lista",
    id: "usId",
    modDatosPers: "/maintenance-usuario/mod-datos-pers",
  },
  masterTableRoutingS: {
    edit: "mastertablas/mastertablas-gestion-sistema/edicion",
    create: "mastertablas/mastertablas-gestion-sistema/creacion",
    list: "mastertablas/mastertablas-gestion-sistema/lista",
    id: "rowid",
  },
  masterTableRoutingD: {
    edit: "mastertablas/mastertablas-datos-tecnicos-vehículo/edicion",
    create: "mastertablas/mastertablas-datos-tecnicos-vehículo/creacion",
    list: "mastertablas/mastertablas-datos-tecnicos-vehículo/lista",
    id: "rowid",
  },
  templatesRouting: {
    edit: "/plantillas/edicion",
    create: "/plantillas/creacion",
    list: "/plantillas/lista",
    id: "paId",
  },
  printFormatsRouting: {
    edit: "formatos-impresion/edicion",
    create: "formatos-impresion/creacion",
    list: "formatos-impresion/lista",
    id: "fiId",
  },
  maintenanceHistoricoBastidor: {
    edit: "/maintenance-historico-bastidor/edicion",
    create: "/maintenance-historico-bastidor/creacion",
    list: "/maintenance-historico-bastidor/lista",
    id: "hbBastidor",
  },

  patronWltp: {
    edit: "/consulta-patron-wltp/display",
    // create: "/consulta-patron-wltp/creacion",
    list: "/consulta-patron-wltp/lista",
    id: "pwId",
  },
  importarDatosAccesorios: {
    upload: "/importar-datos-accesorios/upload",
  },
  exportarHistoricoPlaca: {
    download: "/exportar-historico-placa/download",
  },
  cocMailBox: {
    list: "coc/buzon/lista",
    edit: "coc/buzon/detalle",
    id: "id",
  },
  placaMailBox: {
    list: "placa/buzon/lista",
    edit: "placa/buzon/detalle",
    id: "id",
  },

  placaQuery: {
    list: "placa/consulta/lista",
    edit: "placa/consulta/detalle",
    id: "id",
  },

  placaQueryHistory: {
    list: "placa/consulta/lista",
    edit: "placa/consulta/detalle/historico",
    id: "id",
  },

  placaQueryFiles: {
    list: "/placa/consulta-ficheros-placa",
    edit: "",
    id: "id",
  },
  solicitudCertificadoRoutingModule: {
    datos: "solicitud-certificado/datos",
    // id: "id",
  },
  ayudasGenerales: {
    datos: "información/ayudas-generales/docs",
    id: "id",
  },
  descargaFicheroConcesionario: {
    download: "/descarga-fichero-concesionario/download",
  },
  printsFormatsRoutingCreateEdit: {
    edit: "formatos-impresion/campos/edicion/",
    list: "formatos-impresion/lista",
    id: "id",
  },

  fieldsPrintsFormatsRoutingEdit: {
    edit: "formatos-impresion/campos/edicion/",
    list: "formatos-impresion/edicion",
    id: "id",
  },

  rulesTemplatesRouting: {
    edit: "reglas-plantillas/edicion",
    create: "reglas-plantillas/creacion",
    list: "reglas-plantillas/lista",
    id: "id",
  },

  reformsRouting: {
    edit: "reformas/edicion",
    list: "reformas/lista",
    id: "reId",
  },
  printsRulesRouting: {
    edit: "reglas-impresion/edicion",
    create: "reglas-impresion/creacion",
    list: "reglas-impresion/lista",
    id: "riIndice",
  },

  dataCDTRouting: {
    edit: "datos-cdt/edicion",
    create: "datos-cdt/creacion",
    list: "datos-cdt/lista",
    id: "daId",
  },

  royalDecreeRouting: {
    edit: "real-decreto/edicion-campos-disponibles",
    create: "real-decreto/creacion-campos-disponibles",
    list: "real-decreto/lista-campos-disponibles",
    tree: "real-decreto/campos-especificos-solicitados",
    id: "cdId",
  },

  printParamsRouting: {
    list: "parametros-impresion",
  },
  changePassword: {
    list: "cambiar-password",
  },

  certificatesMailBox: {
    list: "certificados/buzon/lista",
    edit: "certificados/buzon/detalle",
    corregir: "certificados/buzon/edicion",
    id: "id",
  },
  certificatesRequest: {
    data: "certificados/solicitud-certificado/datos",
    inform: "certificados/solicitud-certificado/informe",
    id: "peCreacion",
    list: "certificados/buzon/lista",
  },

  certificatesQuery: {
    list: "certificados/consulta/lista",
    edit: "certificados/consulta/detalle",
    id: "id",
  },

  certificatesQueryHistory: {
    list: "certificados/consulta/lista",
    edit: "certificados/consulta/detalle/historico",
    id: "id",
  },

  cocQuery: {
    list: "coc/consulta/lista",
    edit: "coc/consulta/detalle",
    id: "id",
  },

  cocQueryHistory: {
    list: "coc/consulta/lista",
    edit: "coc/consulta/detalle/historico",
    id: "id",
  },

  personasParams: {
    list: "parámetros-personales",
  },
  adavancedFilters: {
    list: "parámetros-personales/filtros-avanzados",
  },
  personalConcessionaire: {
    list: "/concesionario/datos-concesionario",
  },
  mailBoxRules: {
    list: "reglas-buzon",
  },

  certificatesStatistics: {
    list: "información/estadisticas-certificados",
  },
  certificatesUse: {
    list: "información/estadisticas-uso",
  },
  billingUse: {
    list: "información/estadisticas-facturación",
  },
  cocRequest: {
    list: "coc/solicitud/",
    mailBoxList: "/coc/buzon/lista",
  },
  placaRequest: {
    data: "placa/solicitud-placa/datos",
    mailBoxList: "/placa/buzon/lista",
  },

  fsPlaca: {
    list: "maintenance-historico-bastidor/fsplaca/lista",
    edit: "maintenance-historico-bastidor/fsplaca/detalle",
    id: "id",
  },
};
